module.exports = __webpack_public_path__ + "img/electricidad.26ce615b.jpg";